import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="unstyled-dialog"
export default class extends Controller {
  // element refers to the dialog element where the controller is connected
  connect() {
    this.element.show()
  }

  close() {
    this.element.close()
  }
}
